"use strict";
// Workflow review D1: the numbers in a job's header. Counted from the applications when asked, never stored
// (non-negotiable #10); days running and the deadline are worked out on screen from the job's own dates.
Object.defineProperty(exports, "__esModule", { value: true });
exports.appliedCountOf = appliedCountOf;
/** "Applied": every row of the stage bar's grouped query, whatever stage it is in now (the bar's own stages leave some out). */
function appliedCountOf(rows) {
    return rows.reduce((total, row) => total + row.count, 0);
}
//# sourceMappingURL=job-summary.js.map